







import TransactionsView from '@/components/TransactionsView.vue'
import Vue from 'vue'
import { remittanceBalanceTransactionController } from '~/api/Remittances/remittances.api'
import { RemittanceBalanceTransactionEnum } from '~/utils/interfaces/remittance.interface'
export default Vue.extend({
  components: {
    TransactionsView,
  },
  data() {
    return {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      types: this.$utils.makeSelectable(RemittanceBalanceTransactionEnum),
      controller: remittanceBalanceTransactionController,
    }
  },
})
